<template>
  <section>
    <Feature v-if="isMutiple" :title="$t('GROUP_KEY')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo :fieldNameArr="[$t('TOTAL') + ': ' + quotationList.length]" :fieldWidthArr="[364]"
        :fieldSpanWidthArr="[102]">
        <Select class="Select" slot="a" v-model="formNo" @on-change="changeFormNo">
          <Option v-for="(item, index) in quotationList" :value="item.formNo" :key="index">{{ item.formNo }}</Option>
        </Select>
      </FormRowTwo>
    </Feature>
    <Feature :title="$t('MATERIAL_BASIC_INFORMATION')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo
        :fieldNameArr="[$t('FORM_NO') + ': ', $t('RFQ_TYPE') + ': ', $t('VENDOR_CODE') + ': ', $t('PLANT_CODE') + ': ', $t('VENDOR_PN') + ': ', $t('CATEGORY') + ': ']"
        :fieldWidthArr="[364, 364, 364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102, 102, 102]">
        <Input class="Input" v-model="quotation.formNo" slot="a" disabled />
        <Input class="Input" v-model="rfqType" slot="b" disabled />
        <Input class="Input" v-model="quotation.vendorCode" slot="c" disabled />
        <Input class="Input" v-model="quotation.plant" slot="d" disabled />
        <Input class="Input" v-model="quotation.vendorPart" slot="e" disabled />
        <Input class="Input" value="Others" slot="f" disabled />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('CURRENCY') + ': ', $t('DELTA_PN') + ': ', $t('DESCRIPTION') + ': ', $t('REMARK') + ': ']"
        :fieldWidthArr="[364, 364, 728, 728]" :fieldSpanWidthArr="[102, 102, 102, 102]">
        <Input class="Input" v-model="quotation.currency" slot="a" disabled />
        <Input class="Input" v-model="quotation.deltaPart" slot="b" disabled />
        <Input style="width: 612px" v-model="quotation.deltaPartDesc" type="textarea" slot="c" disabled :rows="1" />
        <Input style="width: 612px" v-model="quotation.ymgrRemark" type="textarea" slot="d" disabled :rows="1" />
      </FormRowTwo>
      <FormRowTwo v-if="quotationDocumentView" :fieldNameArr="[$t('PART_SPECIFICATION') + ': ']">
      </FormRowTwo>
      <PLMDocument v-if="quotationDocumentView" :plmQuotationDocuments="plmQuotationDocuments"
        :quotationUuid="quotation.uuid"></PLMDocument>
    </Feature>

    <Feature :title="$t('BUYER')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo :fieldNameArr="[$t('DELTA_BUYER_NAME') + ': ', $t('TARGET_PRICE') + ': ', $t('EMAIL') + ': ']"
        :fieldWidthArr="[364, 364, 728]" :fieldSpanWidthArr="[102, 102, 102]">
        <Input class="Input" v-model="cpcAccountName" slot="a" disabled />
        <Input class="Input" v-model="quotation.targetPrice" slot="b" disabled />
        <Input style="width: 612px" v-model="quotation.cpcAccountConstactEmail" type="textarea" slot="c" disabled
          :rows="1" />
      </FormRowTwo>

      <FormRowTwo v-show="hasComments" :fieldNameArr="[$t('COMMENTS') + ': ']" :fieldWidthArr="[364]"
        :fieldSpanWidthArr="[102]">
        <Button class="Input" icon="ios-create" slot="a" @click="openComments">{{ $t('COMMENTS') }}</Button>
      </FormRowTwo>

      <FormRowTwo v-if="cpcToVendorAttachmentsExited" :fieldNameArr="[$t('REFERENCE_FILE') + ': ']">
      </FormRowTwo>
      <FormRowTwo v-if="cpcToVendorAttachmentsExited" :fieldNameArr="[$t('')]">
        <Table width="600" border :columns="fileSchemaList" :data="cpcToVendorAttachments" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          </template>
        </Table>
      </FormRowTwo>
    </Feature>

    <Feature :title="$t('QUOTATION')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo :fieldNameArr="['*' + $t('YOUR_PRICE') + ': ', '/1 ' + quotation.unit]" :fieldWidthArr="[364]"
        :fieldSpanWidthArr="[102]">
        <Input class="Input" v-model="price" ref="yourPrice" slot="a" :disabled="!quotation.editable"
          style="border-color:red;border-width:1px;border-style:solid;" />
      </FormRowTwo>
      <Table width="600" :columns="scalePriceColumnList" :data="scalePriceList"></Table>
      <FormRowTwo :fieldNameArr="[$t('RAW_MATERIAL_TYPE') + ': ', $t('RAW_MATERIAL_PRICE') + ': ']"
        :fieldWidthArr="[404, 404]" :fieldSpanWidthArr="[142, 142]">
        <Select class="Select" v-if="quotation.editable" filterable v-model="rawMaterialType" slot="a">
          <Option v-for="(item) in rawMaterialTypeList" :value="item" :key="item">{{ item }}</Option>
        </Select>
        <Input class="Input" v-if="!quotation.editable" v-model="rawMaterialType" slot="a" :disabled="true" />
        <Input class="Input" v-model="rawMaterialPrice" slot="b" :disabled="!quotation.editable" />
      </FormRowTwo>
      <FormRowTwo v-if="quotation.editable"
        :fieldNameArr="['*' + $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')', file == null ? '' : file.name]"
        :fieldWidthArr="[554, 554]" :fieldSpanWidthArr="[292, 292]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button class="Input" icon="ios-cloud-upload" style="border-color:red;border-width:1px;border-style:solid;">{{
            $t('UPLOAD') }}</Button>
        </Upload>
        <Button class="Input" type="primary" v-show="file !== null" slot="b" @click="uploadFile">{{ $t('CLICK_UPLOAD')
        }}</Button>
      </FormRowTwo>
      <FormRowTwo v-if="supplierAttachmentExited" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="showSupplierQuotationFiles" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
            <Button v-if="quotation.editable" type="error" shape="circle" icon="md-close-circle"
              @click="deleteDocument(row)"></Button>
          </template>
        </Table>
      </FormRowTwo>
    </Feature>

    <ButtonRow>
      <Button v-if="quotation.editable" type="primary" @click="Save" slot="0">{{ $t('SAVE') }}</Button>
      <Button v-if="quotation.editable" type="primary" @click="Submit" slot="1">{{ $t('SUBMIT') }}</Button>
      <Button v-if="isMutiple && quotation.editable" type="primary" @click="Upload" slot="2">{{ $t('UPLOAD') }}</Button>
      <Button type="primary" @click="Back" slot="3">{{ $t('BACK') }}</Button>
    </ButtonRow>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="commentsModal"
      :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="comments"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" width="900" sticky :draggable="true" v-model="uploadModel"
      :title="$t('UPLOAD')">
      <FormRow :fieldNameArr="['STEP1']">
        <Button icon="md-cloud-download" type="success" slot="a" @click="downloadSample">{{ $t('DOWNLOAD') }}</Button>
      </FormRow>
      <I style="color: red">Please use excel file, and the first row is column description which will not upload to
        system. Please input your data from second row.</I>
      <FormRow
        :fieldNameArr="['(STEP2) Quotation File sUpload (File Size < 5MB)', batchAttachmentFile == null ? '' : batchAttachmentFile.name]">
        <Upload slot="a" :before-upload="handleBatchAttachmentUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="batchAttachmentFile !== null" slot="b" @click="uploadBatchAttachement">{{
          $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
      <FormRow v-if="batchAttachmentUuid" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="batchAttachmentFiles" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          </template>
        </Table>
      </FormRow>
      <FormRow :fieldNameArr="['Batch Excel File Upload', batchFile == null ? '' : batchFile.name]">
        <Upload slot="a" :before-upload="handleBatchUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="batchFile !== null" slot="b" @click="uploadBatch">{{ $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true" v-model="errorMsgModal"
      :title="$t('QUOTATION')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="errorMsgColumnList" :data="errorMessages" max-height="800"></Table>
      </div>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import { CheckCurrency, CheckNumber, CheckFloat } from "@/util/common"
import { FileSchemaList } from "@/util/tableTitle"
import PLMDocument from '../../components/PLMDocument.vue'
import { DownloadFile, FloraEditorConfig, Translate } from "@/util/common"
import { utils } from "xlsx"
import GroupTitle from "@/views/default/GroupTitle"
import FormRowTwo from '@/components/FormRowTwo'

export default {
  name: "SupplierOthersMatintain",
  props: {
  },
  components: {
    PLMDocument,
    GroupTitle,
    FormRowTwo
  },
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(""),
      comments: '',
      uuid: '',
      formNo: '',
      quotation: {},
      rawMaterialTypeList: [],
      price: '',
      rawMaterialType: '',
      rawMaterialPrice: '',
      file: null,
      batchAttachmentFile: null,
      batchFile: null,
      supplierQuotationFiles: [],
      showSupplierQuotationFiles: [],
      plmQuotationDocuments: [],
      cpcToVendorAttachments: [],
      loadingStatus: false,
      commentsModal: false,
      uploadModel: false,
      errorMsgModal: false,
      errorMessages: [],
      batchAttachmentUuid: "",
      batchAttachmentFiles: [],
      documentColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('FILE_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'fileName',
          align: 'center',
          width: 200,
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLM_FILES')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 120,
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "md-download",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.downloadDocument(params.row)
                },
              },
            })
          }
        },
      ],
      scalePriceList: [],
      scalePriceColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ITEM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'item',
          align: 'center',
          width: 80
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE'); + '<br>' + this.$t('QUANTITY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                type: 'text',
                value: this.scalePriceList[params.index].scaleQuantity
              },
              on: {
                'on-change': (event) => {
                  this.scalePriceList[params.index].scaleQuantity = event.target.value
                }
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                type: 'text',
                value: this.scalePriceList[params.index].scalePrice
              },
              on: {
                'on-change': (event) => {
                  this.scalePriceList[params.index].scalePrice = event.target.value
                }
              }
            })
          }
        }
      ],
      fileSchemaList: FileSchemaList(this),
      errorMsgColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('FORM_NO');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Form No",
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('YOUR_PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Your Price",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Unit",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_QUANTITY') + " 2"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Quantity 2",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_PRICE') + " 2"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Price 2",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_QUANTITY') + " 3"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Quantity 3",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_PRICE') + " 3"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Price 3",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_QUANTITY') + " 4"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Quantity 4",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_PRICE') + " 4"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Price 4",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_QUANTITY') + " 5"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Quantity 5",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE_PRICE') + " 5"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Scale Price 5",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RAW_MATERIAL_TYPE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Raw Material Type",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RAW_MATERIAL_PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Raw Material Price",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ERROR_MESSAGE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "errorMessage",
          render: (h, params) => {
            let html = "<lable>" + params.row.errorMessage + "</lable>";
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          },
          width: 400,
          align: "center",
        },
      ],
    }
  },
  created() {
    const vueInstance = this
    vueInstance.toggleLoading(true)
    if (vueInstance.getSupplierQuotationId()) {
      vueInstance.uuid = this.getSupplierQuotationId()
      vueInstance.$searchSupplierOthers(this).then(vueInstance => {
        console.log(vueInstance)
        vueInstance.toggleLoading(false)
      })
    } else if (this.getQuotationList().length > 0) {
      vueInstance.formNo = this.getQuotationList()[0].formNo
      vueInstance.uuid = this.getQuotationList()[0].uuid
      vueInstance.$searchSupplierOthers(this).then(vueInstance => {
        console.log(vueInstance)
        vueInstance.toggleLoading(false)
      })
    } else {
      vueInstance.toggleLoading(false)
      vueInstance.Back()
    }

    vueInstance.$getMasterData(vueInstance, "RAW_MATERIAL").then(data => {
      data.forEach(rawMaterial => {
        if (rawMaterial.enabled) {
          vueInstance.rawMaterialTypeList.push(rawMaterial.type)
        }
      })
    })
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getQuotationList", "getSupplierQuotationId", "getModalSize"]),
    ...mapActions(["toggleLoading"]),
    Upload() {
      this.uploadModel = true
    },
    downloadSample() {
      let formNos = []
      this.quotationList.forEach(q => {
        formNos.push(q.formNo)
      })
      this.$downloadExcel(this, "supplier/other/batch", JSON.stringify(formNos), "")
    },
    handleBatchAttachmentUpload(file) {
      this.batchAttachmentFile = file;
      return false;
    },
    uploadBatchAttachement() {
      let fd = new FormData()
      fd.append('file', this.batchAttachmentFile)
      this.toggleLoading(true)
      this.$fileHttp
        .post("/attachment/upload-single?description=quotation", fd)
        .then((response) => {
          this.batchAttachmentFiles = []
          this.batchAttachmentFiles.push(response.data)
          this.batchAttachmentUuid = response.data.uuid
          this.batchAttachmentFile = null
          this.toggleLoading(false)
        })
        .catch(() => {
          this.toggleLoading(false)
        })
    },
    handleBatchUpload(file) {
      this.batchFile = file;
      return false;
    },
    async uploadBatch() {
      const vueInstance = this
      let excelData = {
        title: null,
        body: null
      }
      const workBook = await this.$readerWorkBookFromLocal(this.batchFile),
        workSheet = workBook.Sheets[workBook.SheetNames[0]],
        content = utils.sheet_to_json(workSheet, { raw: false })
      excelData.title = Object.keys(content[0])
      excelData.body = content
      vueInstance.errorMessages = []
      excelData.body.forEach(quotation => {
        let scalePriceList = []
        for (let i = 2; i < 6; i++) {
          scalePriceList.push({
            item: i,
            scalePrice: quotation['Scale Price ' + i] ? quotation['Scale Price ' + i] : "",
            scaleQuantity: quotation['Scale Quantity ' + i] ? quotation['Scale Quantity ' + i] : ""
          })
        }

        quotation.errorMessage = (vueInstance.valid(quotation['Form No'],
          quotation['Your Price'],
          quotation['Currency'],
          scalePriceList,
          quotation['Raw Material Type'],
          quotation['Raw Material Price']))
        if (quotation.errorMessage) {
          vueInstance.errorMessages.push(quotation)
        }
      })

      let errorMessage = ""
      if (vueInstance.batchAttachmentUuid == "") {
        errorMessage = errorMessage + "Please Upload Quotation File"
      }

      if (vueInstance.errorMessages.length > 0) {
        vueInstance.batchFile = null
        vueInstance.errorMsgModal = true
      } else if (errorMessage) {
        vueInstance.batchFile = null
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        let fd = new FormData()
        fd.append('file', this.batchFile)
        let formNos = []
        vueInstance.quotationList.forEach(q => {
          formNos.push(q.formNo)
        })
        fd.append('formNoList', formNos)
        fd.append('fileUuid', vueInstance.batchAttachmentUuid)
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/supplier/other/batch-upload", fd)
          .then((response) => {
            vueInstance.toggleLoading(false)
            vueInstance.batchFile = null
            vueInstance.uploadModel = false
            vueInstance.$Swal.fire({
              icon: "info",
              title: Translate("COMMON_MESSAGE_SUCCESS"),
              text: response.data.content[0].status,
            })
            vueInstance.Back()
          })
          .catch((error) => {
            vueInstance.toggleLoading(false)
            vueInstance.batchFile = null
            if (error.response.status == 444) {
              let text = vueInstance.$buildErrorMessage(error)
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                text,
              })
            }
          })
      }
    },
    changeFormNo(formNo) {
      const vueInstance = this
      let temp = this.getQuotationList().find(quotation => quotation.formNo == formNo)
      vueInstance.formNo = temp.formNo
      vueInstance.uuid = temp.uuid
      vueInstance.toggleLoading(true)
      vueInstance.$searchSupplierOthers(this).then(vueInstance => {
        vueInstance.toggleLoading(false)
      })
    },
    openComments() {
      this.commentsModal = true
    },
    downloadAttachment(row) {
      this.$downloadAttachment(this, row.uuid)
    },
    deleteDocument(row) {
      this.supplierQuotationFiles.forEach(attachment => {
        if (attachment.id == row.id) {
          attachment.deleted = true
        }
      })
      this.showSupplierQuotationFiles = this.supplierQuotationFiles.filter(attachment => !attachment.deleted)
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadFile() {
      if (this.showSupplierQuotationFiles.length < 1) {
        let fd = new FormData()
        fd.append('file', this.file)
        fd.append('description', "quotaion attachement")
        this.toggleLoading(true)
        this.$fileHttp
          .post("/attachment/upload-single?description=quotation" + this.quotation.uuid, fd)
          .then((response) => {
            this.supplierQuotationFiles.push(response.data)
            this.showSupplierQuotationFiles.push(response.data)
            this.file = null
            this.toggleLoading(false)
          })
          .catch(() => {
            this.toggleLoading(false)
          })
      } else {
        let text = "Could not upload more than one quotation file."
        this.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    },
    Save() {
      const vueInstance = this
      let errorMessage = vueInstance.valid(vueInstance.quotation.formNo, vueInstance.price, vueInstance.quotation.currency, vueInstance.scalePriceList, vueInstance.rawMaterialType, vueInstance.rawMaterialPrice)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/supplier/update", JSON.stringify(buildCriteria(vueInstance)))
          .then((response) => {
            vueInstance.toggleLoading(false)
          })
          .catch(() => {
            vueInstance.toggleLoading(false)
          })
      }
    },
    Submit() {
      const vueInstance = this
      let errorMessage = vueInstance.valid(vueInstance.quotation.formNo, vueInstance.price, vueInstance.quotation.currency, vueInstance.scalePriceList, vueInstance.rawMaterialType, vueInstance.rawMaterialPrice)
        + vueInstance.$validSupplierAttachments(vueInstance, vueInstance.showSupplierQuotationFiles.length)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/supplier/submit", JSON.stringify(buildCriteria(vueInstance)))
          .then((response) => {
            if (vueInstance.getSupplierQuotationId()) {
              vueInstance.toggleLoading(false)
              vueInstance.Back()
            } else if (vueInstance.getQuotationList().length > 0) {
              vueInstance.$searchSupplierOthers(this).then(vueInstance => {
                vueInstance.toggleLoading(false)
              })
            } else {
              vueInstance.toggleLoading(false)
              vueInstance.Back()
            }
          })
          .catch(() => {
            vueInstance.toggleLoading(false)
          })
      }
    },
    Back() {
      this.$router.push({ name: 'SUPPLIER_MAINTAIN' })
    },
    valid(formNo, price, currency, scalePriceList, rawMaterialType, rawMaterialPrice) {
      const vueInstance = this
      let errorMessage = vueInstance.$validSupplierQuotationPrice(vueInstance, "FormNo(" + formNo + ") -", price, currency)

      let lastScaleQuantity = 1
      let lastScalePrice = 0
      scalePriceList.forEach(element => {
        if (!element.scaleQuantity) {
          if (element.scalePrice) {
            errorMessage = errorMessage + "FormNo(" + formNo + ") -" + "Item " + element.item + ": " + this.$t('PLEASE_KEY_IN_QUANTITY') + " <br>"
          }
        } else {
          if (element.scaleQuantity && !CheckNumber(element.scaleQuantity)) {
            errorMessage = errorMessage + "FormNo(" + formNo + ") -" + "Item " + element.item + ": " + this.$t('QUANTITY_MUST_BE_NUMBER') + " <br>"
          } else {
            if (lastScaleQuantity === "" || lastScaleQuantity === undefined) {
              errorMessage = errorMessage + "FormNo(" + formNo + ") -" + "Item " + element.item + ": " + this.$t('PERIOUS_QUANTITY_IS_EMPTY') + " <br>"
            } else if (Number(element.scaleQuantity) <= Number(lastScaleQuantity)) {
              errorMessage = errorMessage + "FormNo(" + formNo + ") -" + "Item " + element.item + ": " + this.$t('QUANTITY_IS_LESS_THAN_PREVIOUS') + " <br>"
            }
          }
        }
        lastScaleQuantity = element.scaleQuantity

        if (!element.scalePrice) {
          if (element.scaleQuantity) {
            errorMessage = errorMessage + "FormNo(" + formNo + ") -" + "Item " + element.item + ": " + this.$t('PLEASE_KEY_IN_PRICE') + " <br>"
          }
        } else {
          if (element.scalePrice && !CheckFloat(element.scalePrice)) {
            errorMessage = errorMessage + "FormNo(" + formNo + ") -" + "Item " + element.item + ": " + this.$t('PRICE_MUST_BE_NUMBER') + " <br>"
          } else {
            if (CheckCurrency(element.scalePrice)) {
              if (element.scalePrice.toString().split("").reverse().join("").indexOf(".") > 4) {
                errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PRICE_IS_MORE_THAN_FOUR_DIGITS') + " <br>"
              }
            } else {
              if (element.scalePrice.toString().split("").reverse().join("").indexOf(".") > 6) {
                errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PRICE_IS_MORE_THAN_SIX_DIGITS') + " <br>"
              }
            }

            if (lastScalePrice === "" || lastScalePrice === undefined) {
              errorMessage = errorMessage + "FormNo(" + formNo + ") -" + "Item " + element.item + ": " + this.$t('PERIOUS_PRICE_IS_EMPTY') + " <br>"
            } else if (Number(element.scalePrice) >= Number(lastScalePrice)) {
              if (element.item == "2") {
                if (Number(element.scalePrice) >= Number(price)) {
                  errorMessage = errorMessage + "FormNo(" + formNo + ") -" + "Item " + element.item + ": " + this.$t('PRICE_IS_MORE_THAN_PREVIOUS') + " <br>"
                }
              } else {
                errorMessage = errorMessage + "FormNo(" + formNo + ") -" + "Item " + element.item + ": " + this.$t('PRICE_IS_MORE_THAN_PREVIOUS') + " <br>"
              }
            }
          }
        }
        lastScalePrice = element.scalePrice
      })

      if (rawMaterialType) {
        if (!rawMaterialPrice) {
          errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PLEASE_KEY_IN_RAW_MATERIAL_PRICE') + " <br>"
        } else if (!CheckFloat(rawMaterialPrice)) {
          errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('RAW_MATERIAL_PRICE_MUST_BE_NUMBER') + " <br>"
        }
      } else {
        if (rawMaterialPrice) {
          errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PLEASE_SELECT_RAW_MATERIAL') + " <br>"
        }
      }
      return errorMessage
    },
  },
  computed: {
    quotationList() {
      return this.getQuotationList()
    },
    isMutiple() {
      return this.getQuotationList() && this.getQuotationList().length > 0
    },
    supplierAttachmentExited() {
      return this.showSupplierQuotationFiles && this.showSupplierQuotationFiles.length > 0
    },
    quotationDocumentView() {
      return this.plmQuotationDocuments && this.plmQuotationDocuments.length > 0
    },
    cpcToVendorAttachmentsExited() {
      return this.cpcToVendorAttachments && this.cpcToVendorAttachments.length > 0
    },
    rfqType() {
      if (this.quotation.rfqType) {
        return this.quotation.rfqType.description
      } else {
        ""
      }
    },
    cpcAccountName() {
      return this.quotation.cpcAccount ? this.quotation.cpcAccount.name : ""
    },
    hasComments() {
      return this.comments != ""
    },
    modalSize() {
      return this.getModalSize()
    }
  }
}

function buildCriteria(vueInstance) {
  return {
    'currency': vueInstance.quotation.currency,
    'price': vueInstance.price,
    'rawMaterialType': vueInstance.rawMaterialType,
    'rawMaterialPrice': vueInstance.rawMaterialPrice,
    'scalePrices': vueInstance.scalePriceList.filter(data => data.scaleQuantity != "" && data.scalePrice != ""),
    'supplierQuotationFiles': vueInstance.supplierQuotationFiles,
    'uuid': vueInstance.quotation.uuid,
    'category': 'OTHERS',
  }
}
</script>

<style scoped></style>
